<template>
  <div class="" v-if="item">
      <div class="board">
        <div class="boardrd first">
          <span class="ml10">{{item.msgTitle}}</span>
          <span class="newicon ml5">N</span>
        </div>
        <div class="boardrd">
          <!--img src="@/assets/img/peanutlogo.svg"--><span>{{dateFormat(item.sendDate)}}</span>
        </div>
        <div class="boardrd">
          <p class="rdcon">{{item.msgDesc}}</p>
        </div>
      </div>
      <div class="applibtns">
         <a v-if="prevItem" @click="onMessageClick(prevItem)">{{$t('front.board.prev')}}</a>
         <a @click="onMessageList(false)">{{$t('front.board.list')}}</a>
         <a v-if="nextItem" @click="onMessageClick(nextItem)">{{$t('front.board.next')}}</a>
      </div>
    </div>
</template>

<script>

import { getMsgList, setMsgRead } from '@/api/board'
import { mapState } from 'vuex'

export default {
  name: 'messageread',
  data () {
    return {
      prevItem: null,
      nextItem: null,
      item: null,
      list: null
    }
  },
  async created () {
    this.msgIdx = this.$route.params.msgIdx
    await this.loadList(1)
    if (this.list.length > 0) {
      for (let i = 0, iLen = this.list.length; i < iLen; i++) {
        const data = this.list[i]
        if (data.msgIdx.toString() === this.msgIdx) {
          this.item = data
          if (this.list[i + 1]) {
            this.prevItem = this.list[i + 1]
          }
          if (this.list[i - 1]) {
            this.nextItem = this.list[i - 1]
          }
        }
      }
    }

    this.setRead()
  },
  computed: {
    ...mapState([
      'userData'
    ])
  },
  methods: {
    async loadList (page) {
      const params = {
        page: page || this.pageInfo.page
      }
      await getMsgList(params).then(response => {
        const result = response.data

        if (result.resultCode === '0') {
          const list = result.data.list
          if (result.data.pageInfo) {
            this.pageInfo = result.data.pageInfo
          }
          this.list = list
        }
      })
    },
    setRead () {
      this.item.status = 'R'

      const param = {
        msgIdx: this.item.msgIdx,
        recieveId: this.item.recieveId
      }
      setMsgRead(param).then(response => {

      })
    },
    onMessageList (isMobile) {
      if (isMobile) {
        this.goPageByName('msg')
      } else {
        this.goPageByName('msg')
      }
    },
    onMessageClick (item, isMobile) {
      item.list = JSON.stringify(this.list)
      this.goPageByName('msgread', item)
    }
  }
}
</script>
<style src="@/styles/striNew.css"></style>

<style scoped>
.board {
  width: 100% !important;
  margin: 24px 0 0 !important;
  padding: 0 !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05) !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.boardrd {
  min-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  margin: 0 !important;
  padding: 0 20px !important;
  border-bottom: 1px solid #dfe6ef !important;
  background: #ffffff !important;
  color: #475569 !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  box-sizing: border-box !important;
}

.boardrd.first {
  min-height: 58px !important;
  border-top: 3px solid #2f6df6 !important;
  background: #f8fafc !important;
  color: #111827 !important;
}

.boardrd.first .ml10 {
  margin-left: 0 !important;
  color: #111827 !important;
  font-size: 16px !important;
  font-weight: 900 !important;
  letter-spacing: -0.2px !important;
}

.boardrd:nth-child(2) {
  color: #475569 !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.boardrd:nth-child(2)::before {
  content: '보낸시간' !important;
  display: inline-flex !important;
  align-items: center !important;
  height: 23px !important;
  margin-right: 8px !important;
  padding: 0 9px !important;
  border: 1px solid #d4ddeb !important;
  border-radius: 999px !important;
  background: #eef2f7 !important;
  color: #334155 !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  line-height: 23px !important;
  white-space: nowrap !important;
  box-sizing: border-box !important;
}

.boardrd:last-child {
  min-height: 150px !important;
  align-items: flex-start !important;
  padding: 24px 20px 30px !important;
  border-bottom: 0 !important;
  background: #ffffff !important;
}

.rdcon {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  color: #1f2937 !important;
  font-size: 14px !important;
  line-height: 1.75 !important;
  white-space: pre-wrap !important;
  word-break: break-word !important;
  box-sizing: border-box !important;
}

.newicon {
  min-width: 15px !important;
  height: 15px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-left: 4px !important;
  padding: 0 3px !important;
  border-radius: 2px !important;
  background: #ef233c !important;
  color: #ffffff !important;
  font-size: 10px !important;
  font-weight: 900 !important;
  line-height: 15px !important;
  box-sizing: border-box !important;
}

.applibtns {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  margin: 32px 0 0 !important;
  padding: 0 !important;
}

.applibtns a {
  min-width: 138px !important;
  height: 34px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 18px !important;
  border: 1px solid #5969d7 !important;
  border-radius: 6px !important;
  background: #5969d7 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 800 !important;
  line-height: 34px !important;
  text-decoration: none !important;
  cursor: pointer !important;
  box-shadow: 0 8px 16px rgba(89, 105, 215, 0.16) !important;
  box-sizing: border-box !important;
}

.applibtns a:hover {
  border-color: #4656c6 !important;
  background: #4656c6 !important;
}

@media (max-width: 1000px) {
  .board {
    margin-top: 16px !important;
    border-radius: 10px !important;
  }

  .boardrd {
    min-height: auto !important;
    flex-wrap: wrap !important;
    padding: 13px 14px !important;
  }

  .boardrd.first {
    min-height: auto !important;
  }

  .boardrd.first .ml10 {
    font-size: 15px !important;
  }

  .boardrd:last-child {
    min-height: 120px !important;
    padding: 18px 14px 22px !important;
  }

  .applibtns {
    margin-top: 22px !important;
  }

  .applibtns a {
    min-width: 110px !important;
  }
}
</style>
